<rpe-custom-tool-tip [overlayInput]="overlayInput">
    <div class="content" [innerHTML]="matIconOverlayInput.text">
    </div>
</rpe-custom-tool-tip>